// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsResidenceWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { CappsResidenceWebApiHandler_validateAddress } from '@zg-rentals/ts-capps-client';

import type { ValidateAddressWebApiResponseDto } from '@zg-rentals/ts-capps-client';

interface ValidateAddressParams {
  city: string;
  state: string;
  zipcode: string;
}

export interface CappsResidenceWebApiHandler_validateAddress_Args {
  getParams: ValidateAddressParams;
}

export type CappsResidenceWebApiHandler_validateAddress_Options = UseMutationOptions<
  ValidateAddressWebApiResponseDto,
  unknown,
  CappsResidenceWebApiHandler_validateAddress_Args
>;

export const useCappsResidenceWebApiHandler_validateAddress = ({
  httpClient,
  ...options
}: Omit<CappsResidenceWebApiHandler_validateAddress_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsResidenceWebApiHandler_validateAddress_Args) =>
      CappsResidenceWebApiHandler_validateAddress(args.getParams, httpClient),
  });
};
